// Creative Skills organized by subcategories
export const CREATIVE_SKILLS_CATEGORIES = [
  {
    name: 'Visual Design',
    skills: [
      'Graphic Design', 'UI/UX Design', 'Web Design',
      'Logo Design', 'Brand Design', 'Typography',
      'Color Theory', 'Layout Design', 'Digital Illustration',
      'Print Design', 'Package Design', 'Environmental Design',
      'Motion Graphics', 'Visual Identity', 'Design Systems'
    ]
  },
  {
    name: 'Digital Art',
    skills: [
      'Digital Painting', 'Digital Illustration', '3D Modeling',
      'Character Design', 'Concept Art', 'Digital Animation',
      'Texture Design', 'Digital Sculpting', 'Vector Art',
      'Pixel Art', 'Game Art', 'Digital Effects',
      'Digital Composition', 'Digital Photography', 'Digital Retouching'
    ]
  },
  {
    name: 'Traditional Art',
    skills: [
      'Drawing', 'Painting', 'Sculpture',
      'Printmaking', 'Ceramics', 'Mixed Media',
      'Illustration', 'Life Drawing', 'Portrait Art',
      'Landscape Art', 'Abstract Art', 'Figure Drawing',
      'Still Life', 'Watercolor', 'Oil Painting'
    ]
  },
  {
    name: 'Photography',
    skills: [
      'Digital Photography', 'Portrait Photography', 'Landscape Photography',
      'Product Photography', 'Event Photography', 'Street Photography',
      'Fashion Photography', 'Photo Editing', 'Studio Lighting',
      'Composition', 'Color Correction', 'Photo Retouching',
      'Documentary Photography', 'Architectural Photography', 'Food Photography'
    ]
  },
  {
    name: 'Video Production',
    skills: [
      'Video Editing', 'Cinematography', 'Film Direction',
      'Video Production', 'Motion Graphics', 'Sound Design',
      'Color Grading', 'Storyboarding', 'Video Effects',
      'Live Streaming', 'Video Animation', 'Video Scripting',
      'Camera Operation', 'Lighting Design', 'Post-Production'
    ]
  },
  {
    name: 'Animation',
    skills: [
      '2D Animation', '3D Animation', 'Character Animation',
      'Motion Graphics', 'Stop Motion', 'Visual Effects',
      'Rigging', 'Compositing', 'Animation Timing',
      'Animation Principles', 'Animation Software', 'Animation Direction',
      'Animation Storyboarding', 'Animation Design', 'Animation Production'
    ]
  },
  {
    name: 'Music & Audio',
    skills: [
      'Music Production', 'Sound Design', 'Audio Engineering',
      'Music Composition', 'Sound Mixing', 'Sound Editing',
      'Voice Acting', 'Music Recording', 'Audio Post-Production',
      'Music Theory', 'Digital Audio', 'Music Software',
      'Sound Effects', 'Music Performance', 'Audio Equipment'
    ]
  },
  {
    name: 'Writing & Content',
    skills: [
      'Creative Writing', 'Copywriting', 'Content Creation',
      'Scriptwriting', 'Story Development', 'Editorial Writing',
      'Blog Writing', 'Technical Writing', 'Content Strategy',
      'Content Editing', 'Content Planning', 'Content Marketing',
      'Narrative Design', 'Content Management', 'Content Standards'
    ]
  },
  {
    name: 'Game Design',
    skills: [
      'Game Concept', 'Level Design', 'Game Mechanics',
      'Game Balance', 'Game Systems', 'Game Documentation',
      'Game Testing', 'Game Production', 'Game Art',
      'Game Animation', 'Game Sound', 'Game Writing',
      'Game UI/UX', 'Game Development', 'Game Marketing'
    ]
  },
  {
    name: 'Fashion Design',
    skills: [
      'Fashion Illustration', 'Pattern Making', 'Garment Construction',
      'Textile Design', 'Fashion Styling', 'Collection Development',
      'Fashion Trends', 'Fashion Marketing', 'Fashion Production',
      'Fashion Photography', 'Fashion Shows', 'Fashion Writing',
      'Fashion Branding', 'Fashion Technology', 'Sustainable Fashion'
    ]
  },
  {
    name: 'Interior Design',
    skills: [
      'Space Planning', 'Interior Styling', 'Color Schemes',
      'Furniture Design', 'Lighting Design', 'Material Selection',
      'Interior Drawing', 'Interior Rendering', 'Design Presentation',
      'Project Management', 'Sustainable Design', 'Commercial Design',
      'Residential Design', 'Design Software', 'Design Standards'
    ]
  },
  {
    name: 'Creative Strategy',
    skills: [
      'Creative Direction', 'Art Direction', 'Brand Strategy',
      'Creative Planning', 'Creative Management', 'Creative Development',
      'Creative Research', 'Creative Presentation', 'Creative Tools',
      'Creative Standards', 'Creative Process', 'Creative Innovation',
      'Creative Leadership', 'Creative Vision', 'Creative Execution'
    ]
  }
];

// Export flattened list for backward compatibility
export const CREATIVE_SKILLS = CREATIVE_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
